import { EventDispatcher } from '../events/EventDispatcher';

/** flash.display.LoaderInfo (static description of the "main SWF" for the port). */
export class LoaderInfo extends EventDispatcher {
  /** @internal */ $content: any;
  /** @internal */ $parameters: Record<string, string>;
  /** @internal */ $url: string;
  /** @internal */ $width: number;
  /** @internal */ $height: number;
  /** @internal */ $frameRate: number;
  /** @internal */ $swfVersion: number;

  constructor(opts: { content?: any; parameters?: Record<string, string>; url?: string; width?: number; height?: number; frameRate?: number; swfVersion?: number } = {}) {
    super();
    this.$content = opts.content ?? null;
    this.$parameters = { ...(opts.parameters ?? {}) };
    this.$url = opts.url ?? '';
    this.$width = opts.width ?? 807;
    this.$height = opts.height ?? 600;
    this.$frameRate = opts.frameRate ?? 50;
    this.$swfVersion = opts.swfVersion ?? 14;
  }

  get content(): any {
    return this.$content;
  }
  get parameters(): Record<string, string> {
    return this.$parameters;
  }
  get url(): string {
    return this.$url;
  }
  get loaderURL(): string {
    return this.$url;
  }
  get width(): number {
    return this.$width;
  }
  get height(): number {
    return this.$height;
  }
  get frameRate(): number {
    return this.$frameRate;
  }
  get swfVersion(): number {
    return this.$swfVersion;
  }
  get actionScriptVersion(): number {
    return 3;
  }
  get bytesLoaded(): number {
    return 1;
  }
  get bytesTotal(): number {
    return 1;
  }
  get applicationDomain(): any {
    return null;
  }
}
